(() => {
  const glassPanels = document.querySelectorAll('.os-glass');
  if (!glassPanels.length) return;

  let rafId = null;

  function updateGlassLight() {
    const vh = window.innerHeight;

    glassPanels.forEach(panel => {
      const rect = panel.getBoundingClientRect();
      const progress = Math.min(
        Math.max((vh - rect.top) / (vh + rect.height), 0),
        1
      );

      panel.style.setProperty('--light-y', `${progress * 100}%`);
      panel.style.setProperty('--light-x', '50%');
    });

    rafId = null;
  }

  window.addEventListener('scroll', () => {
    if (!rafId) rafId = requestAnimationFrame(updateGlassLight);
  });

  updateGlassLight();
})();